import React, { FormEvent, useState } from 'react'
import { Alert, Button, Form } from "react-bootstrap";
import { ShieldLockFill } from "react-bootstrap-icons";
import { useNavigate } from 'react-router-dom';
import { login } from '../services/Session';

interface Props {
    onSuccess: () => void;
}

export default function Login({ onSuccess }: Props) {

    const navigate = useNavigate();
    const [message, setMessage] = useState<string>('');
    const [success, setSuccess] = useState<string>('');
    const [username, setUsername] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [submitting, setSubmitting] = useState<boolean>(false);

    const onClickSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (submitting || success !== '') {
            return;
        }

        setSubmitting(true);
        setMessage('');
        const res = await login(username, password);
        setSubmitting(false);

        if (res.status) {
            setSuccess('Accesso eseguito con successo!');
            window.setTimeout(() => {
                onSuccess();
                navigate('/admin/list');
            }, 800);
        } else {
            setMessage(res.message || 'Credenziali errate');
            window.setTimeout(() => setMessage(''), 1500);
        }
    }

    return (
        <div className="admin-card admin-login">
            <div className="admin-card-body">
                <div className="brand-mark"><ShieldLockFill /></div>
                <h1>Accedi</h1>
                <p className="text-muted mb-4">Sistema di import utenti webinar</p>

                <form onSubmit={(e: FormEvent<HTMLFormElement>) => onClickSubmit(e)}>
                    <Form.Group className="mb-3" controlId="login-username">
                        <Form.Label>Username</Form.Label>
                        <Form.Control type="text" autoComplete="username" onChange={(e) => setUsername(e.target.value)}/>
                    </Form.Group>
                    <Form.Group className="mb-4" controlId="login-password">
                        <Form.Label>Password</Form.Label>
                        <Form.Control type="password" autoComplete="current-password" onChange={(e) => setPassword(e.target.value)}/>
                    </Form.Group>
                    <Button type="submit" className="w-100" disabled={submitting}>
                        {submitting ? 'Accesso in corso...' : 'Accedi'}
                    </Button>
                </form>

                { message !== '' &&
                <Alert variant="danger" className="mt-4 mb-0">{message}</Alert> }

                { success !== '' &&
                <Alert variant="success" className="mt-4 mb-0">{success}</Alert> }
            </div>
        </div>
    )
}
